document.addEventListener("DOMContentLoaded", function () {
  const sliderWrapper = document.querySelector("product-recommendations");
  if (!sliderWrapper) return;

  const observer = new MutationObserver(function () {
    const slider = sliderWrapper.querySelector('[id^="RelatedProducts-"]');
    const slides = sliderWrapper.querySelectorAll(".related-product");
    const nextBtn = sliderWrapper.querySelector(".related-products-slider-next-button");
    const prevBtn = sliderWrapper.querySelector(".related-products-slider-prev-button");

    if (!slider || slides.length === 0 || !nextBtn || !prevBtn) return;

    observer.disconnect();

    let currentIndex = 0;
    let itemWidth = 0;
    let gap = 0;
    let step = 0;
    let visibleItems = 4;
    const totalItems = slides.length;

    function calculateStep() {
      visibleItems = window.innerWidth <= 989 ? 2 : 4;
      itemWidth = slides[0].getBoundingClientRect().width;

      if (slides.length > 1) {
        const gapCalc = slides[1].offsetLeft - slides[0].offsetLeft - itemWidth;
        gap = gapCalc > 0 ? gapCalc : 0;
      } else {
        gap = 0;
      }

      step = itemWidth + gap;

      const maxIndex = totalItems - visibleItems;
      if (currentIndex > maxIndex) currentIndex = maxIndex;

      updateSliderPosition(false);
      disablePrevNextButtons();
    }

    function updateSliderPosition(smooth = true) {
      const scrollX = step * currentIndex;
      slider.scrollTo({
        left: scrollX,
        behavior: smooth ? 'smooth' : 'auto'
      });
      disablePrevNextButtons();
    }

    function disablePrevNextButtons() {
      const maxIndex = totalItems - visibleItems;
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= maxIndex;
    }

    nextBtn.addEventListener("click", () => {
      const maxIndex = totalItems - visibleItems;
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateSliderPosition();
      }
    });

    prevBtn.addEventListener("click", () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateSliderPosition();
      }
    });

    slider.addEventListener("scroll", () => {
      const approxIndex = slider.scrollLeft / step;
      currentIndex = Math.round(approxIndex);
      disablePrevNextButtons();
    });

    let touchStartX = 0;
    slider.addEventListener("touchstart", (e) => {
      touchStartX = e.touches[0].clientX;
    });

    slider.addEventListener("touchend", (e) => {
      const touchEndX = e.changedTouches[0].clientX;
      const diff = touchStartX - touchEndX;
      const maxIndex = totalItems - visibleItems;

      if (Math.abs(diff) > 50) {
        if (diff > 0 && currentIndex < maxIndex) {
          currentIndex++;
        } else if (diff < 0 && currentIndex > 0) {
          currentIndex--;
        }
        updateSliderPosition();
      }
    });

    calculateStep();
    window.addEventListener("resize", calculateStep);
  });

  observer.observe(sliderWrapper, { childList: true, subtree: true });
});
